import React, { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import Footer from "../pallet/Footer";
import AssetQuantityField from "../../../../views/inventory/requests/AssetQuantityField";

const styles = {
  button: {
    minWidth: 100,
  },
};

export default function Step2({ total, onBack, onQuantityChange, onNext }) {
  const [value, setValue] = useState(0);

  const handleNext = () => {
    onQuantityChange(value);
    onNext();
  };

  const handleChange = value => {
    if (value > total) {
      return null;
    }

    setValue(value);
  };

  return (
    <>
      <DialogContent>
        <Box textAlign="center" mb={3} minHeight={300} display="flex" alignItems="center">
          <Box width="100%">
            <Typography color="textPrimary" mb={4}>
              How much quantity would you like to move?
            </Typography>
            <Box mt={4}>
              <AssetQuantityField
                quantity={value}
                onChange={handleChange}
                size="large"
                quantityProps={{
                  label: "Quantity to Move",
                  style: { minWidth: 160 },
                  InputLabelProps: {
                    shrink: true,
                  },
                  autoFocus: true,
                }}
              />
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <Footer step={2}>
        <Box />
        <Box display="flex" gap={1}>
          <Button variant="outlined" onClick={onBack} sx={styles.button}>
            Back
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleNext}
            disabled={!value}
            sx={styles.button}
          >
            Next
          </Button>
        </Box>
      </Footer>
    </>
  );
}
